module.exports = __webpack_public_path__ + "static/media/1_A1_09.fb78b556.png";